import { Link } from "react-router-dom";
import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { CallToAction } from "@/app/components/legacy-components";
import { useMessenger } from "@/app/hooks/use-messenger";
import { ROUTES } from "@/app/router";
import { useActiveSubscriptions } from "@/features/billing/hooks";
import { NewMedicationRequestButton } from "@/features/my-meds/components";
import {
  useAvailableRefillRequests,
  useCurrentMedicationRequests,
} from "@/features/my-meds/hooks";
import { PRICE_TYPE } from "@/shared/domains";
import { usePageTitle } from "@/shared/hooks";
import { Button } from "@/shared/ui";
import {
  CurrentMedicationRequests,
  MyMedsHeader,
  PastMedicationRequests,
} from "./sections";

export const MyMedsOverview = () => {
  usePageTitle(t`My meds`);

  const { data: currentMedicationRequests } = useCurrentMedicationRequests();
  const { data: availableRefillRequests } = useAvailableRefillRequests();
  const { data: activeSubscriptions } = useActiveSubscriptions();

  const {
    actions: { showMessenger },
  } = useMessenger();

  const hasMedicationRequests = Boolean(currentMedicationRequests?.length);
  const hasAvailableRefillRequests = Boolean(availableRefillRequests?.length);
  const hasOnlyOneTimeProducts = Boolean(
    activeSubscriptions?.every(
      (subscription) =>
        subscription.currentProduct.price.type === PRICE_TYPE.ONE_TIME,
    ),
  );

  const showGoToShopButton =
    !hasAvailableRefillRequests && hasOnlyOneTimeProducts;
  const showNewMedicationButton = hasAvailableRefillRequests;
  const showStickyButton = showGoToShopButton || showNewMedicationButton;

  return (
    <ScreenLayout>
      <MyMedsHeader />

      <CurrentMedicationRequests />

      <PastMedicationRequests />

      <CallToAction
        title={t`Having any trouble with your medication delivery?`}
        description={t`Get in touch with our support team!`}
        buttonText={t`Get in touch`}
        onClick={showMessenger}
      />

      {hasMedicationRequests && showStickyButton && (
        <div className="sticky bottom-0 -m-6 mt-1 bg-white p-6 py-5 shadow-modal-footer md:hidden">
          {showGoToShopButton ? (
            <Button size="lg" asChild>
              <Link to={ROUTES.SHOP.OVERVIEW}>{t`Go to Shop`}</Link>
            </Button>
          ) : (
            <NewMedicationRequestButton />
          )}
        </div>
      )}
    </ScreenLayout>
  );
};
